import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import muiThemeable from 'material-ui/styles/muiThemeable';



function ReadyFlatButton(props) {
  const buttonStyle = {
    border: `1px solid ${props.muiTheme.palette.primary1Color}`,
    borderRadius: 3,
    height: 36,
    lineHeight: '20px'
  };
  let readyStyle = buttonStyle;
  let {muiTheme, style, ...rest} = props;
  if (props.style){
    readyStyle = {
       ...readyStyle,
       ...props.style
      };
  };

  
  return <FlatButton style={readyStyle} {...rest}/>;

};

export default muiThemeable()(ReadyFlatButton);


// WEBPACK FOOTER //
// ./src/components/FlatButton.js